







import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import createjs from 'createjs-npm';
import Game from '@/servers/modules/game/index'; // server
import { Howl, Howler } from 'howler';
import { Base, App } from '../common/base';
import { config } from './config.js';
import log from '../../../../servers/modules/vocabulary/log';

@Component({
  components: {
  },
})
export default class extends Vue {
    @Getter public getGameLoading: any;

    @Mutation public setDataLoading: any;

    @Mutation public setGameLoading: any;

    private app: any;

    private data: any = [];

    // bg music
    private bgMusic: any;

    // 当前选中的下标
    private currentActiveIndex: any;

    // 当前选中的id
    private currentActiveId: any;

    // 第几次点击
    private clickTimes: number = 0;

    // 当前得分
    private scoreNumber: number = 0;

    // 当前错误次数
    private errNumber: number = 0;

    // 倒计时 3分钟
    private countdownTime: number = 2 * 60 * 1000;

    // 当前时间
    private currentCountDownTime: number = 2 * 60 * 1000;

    // 定时器
    private countdownTimer: any;

    // 连续做对题数
    private currencyRightNumber: number = 0;

    // 进度条设计稿宽度
    private progressWidth: number = 797;

    // gameStatistics
    private gameStatisticsId: any;

    private residueDegree: any;

    // 是否记录排行
    private playModel: any = 1;

    // 参数
    private para: any = {
      accuracyNum: '', // 正确数量
      courseId: window.LS.get('vteData').course.courseId, // 课程编号
      errorNum: '', // 错误数量
      firstLoad: 0, // 0-第一次加载，1-非第一次加载
      gameId: 1, // 游戏编号
      gameStatisticsId: '', // 游戏记录编号
      playModel: 1, // 0-不记录成绩，1-记录成绩,默认为1
      userId: window.LS.get('vteData').user.userId, // 学生编号
      sendScore: 1, // 不发送成绩
    }

    private canClick: boolean = true;

    private created() {
      // this.setDataLoading(false);
    }

    private beforeDestroy() {
      createjs.Tween.removeAllTweens();
      this.bgMusic.stop();
      this.setDataLoading(true);
      this.setGameLoading(true);
    }

    private mounted() {
      const that: any = this;
      this.app = new createjs.Stage('root');
      // Howl
      const mousePointOver: any = new Howl({
        src: [require('@/assets/images/game/linker/sound1.mp3')],
      });
      this.bgMusic = new Howl({
        src: [require('@/assets/images/game/linker/mapBGM.mp3')],
        loop: true,
        // autoplay: true,
      });
      const soundscore: any = new Howl({
        src: [require('@/assets/images/game/linker/score.mp3')],
      });
      const sounderror: any = new Howl({
        src: [require('@/assets/images/game/linker/error.mp3')],
      });
      class CurrentGame extends Base {
        constructor(options: any) {
          super(options);
          // this.config = config
        }

            // 倒计时
            private countTime: any = createjs.Tween.get(that.progressshape);

            // 得分box
            private scoreContainer = new createjs.Container();

            // 失败box
            private errContainer = new createjs.Container();

            // 倒计时
            private progressshape: any;

            protected initStage(): void {
              // sprites 引入图片
              const bg = new createjs.Bitmap(App.loader.getResult('bg'));
              const back = new createjs.Bitmap(App.loader.getResult('back'));
              const title = new createjs.Bitmap(App.loader.getResult('title'));
              const btn = new createjs.Bitmap(App.loader.getResult('btn'));
              // game
              const plantl = new createjs.Bitmap(App.loader.getResult('plantl'));
              const plantr = new createjs.Bitmap(App.loader.getResult('plantr'));
              const poster = new createjs.Bitmap(App.loader.getResult('poster'));
              const messagebg = new createjs.Bitmap(App.loader.getResult('message'));
              const goback = new createjs.Bitmap(App.loader.getResult('goback'));
              // level
              const score = new createjs.Bitmap(App.loader.getResult('score'));
              const wrong = new createjs.Bitmap(App.loader.getResult('wrong'));
              const sound = new createjs.Bitmap(App.loader.getResult('sound'));
              const nosound = new createjs.Bitmap(App.loader.getResult('nosound'));
              const logo = new createjs.Bitmap(App.loader.getResult('logo'));
              const right = new createjs.Bitmap(App.loader.getResult('right'));
              // 木板
              const show = new createjs.Bitmap(App.loader.getResult('show'));
              const mask = new createjs.Bitmap(App.loader.getResult('mask'));
              const errdialog = new createjs.Bitmap(App.loader.getResult('errdialog'));
              const errclose = new createjs.Bitmap(App.loader.getResult('close'));


              // 得分记录 失败次数记录
              // let scoreContainer = new createjs.Container();
              // let wrongContainer = new createjs.Container();
              const readyContainer = new createjs.Container();
              const gameContainer = new createjs.Container();
              // 初始化得分
              const scoreTimes = this.score(that.scoreNumber);
              // 初始化错误次数
              const errTimesMax = this.err(that.errNumber);
              this.errContainer.addChild(errTimesMax);
              this.scoreContainer.addChild(scoreTimes);
              this.scoreContainer.setTransform(1181, 54, 1, 1, 0, 0, 0, 0, 0);
              score.setTransform(1181, 54, 1, 1, 0, 0, 0, 0, 0);
              this.errContainer.setTransform(1476, 53, 1, 1, 0, 0, 0, 0, 0);
              wrong.setTransform(1476, 53, 1, 1, 0, 0, 0, 0, 0);
              // progress box
              const progressContainer = new createjs.Container();
              const progressbox = new createjs.Bitmap(App.loader.getResult('progressbox'));
              const progress = new createjs.Bitmap(App.loader.getResult('progress'));
              this.progressshape = new createjs.Shape();
              this.progressshape.graphics.drawRect(0, 0, progress.getBounds().width, progress.getBounds().height);
              progressContainer.addChild(progressbox, progress, this.progressshape);
              progressContainer.setTransform(252, 70, 1, 1, 0, 0, 0, 0, 0);
              progressbox.setTransform(0, 0, 1, 1, 0, 0, 0, 0, 0);
              progress.setTransform(14, 15, 1, 1, 0, 0, 0, 0, 0);
              this.progressshape.setTransform(14, 15, 1, 1, 0, 0, 0, 0, 0);
              // mask
              progress.mask = this.progressshape;
              // progress animation

              bg.setTransform(0, 0, 1, 1, 0, 0, 0, 0, 0);
              title.setTransform(159, 349, 1, 1, 0, 0, 0, 0, 0);
              btn.setTransform(463 + btn.getBounds().width / 2, 654 + btn.getBounds().height / 2, 1, 1, 0, 0, 0, btn.getBounds().width / 2, btn.getBounds().height / 2);
              readyContainer.addChild(bg, title, btn);
              // back.setTransform(0, 0, 1, 1, 0, 0, 0, 0, 0);
              // game
              poster.setTransform(1584 + poster.getBounds().width / 2, 753 + poster.getBounds().height, 1, 1, 0, 0, 0, poster.getBounds().width / 2, poster.getBounds().height);
              plantl.setTransform(0, 861, 1, 1, 0, 0, 0, 0, 0);
              plantr.setTransform(1661, 938, 1, 1, 0, 0, 0, 0, 0);
              goback.setTransform(47, 53, 1, 1, 0, 0, 0, 0, 0);
              sound.setTransform(1768, 53, 1, 1, 0, 0, 0, 0, 0);
              nosound.setTransform(1768, 53, 1, 1, 0, 0, 0, 0, 0);
              logo.setTransform(845, 982, 1, 1, 0, 0, 0, 0, 0);

              errdialog.setTransform(612, 304, 1, 1, 0, 0, 0, 0, 0);
              errclose.setTransform(1222, 321, 1, 1, 0, 0, 0, 0, 0);

              // mask.setTransform(170, 441, 1, 1, 0, 0, 0, 0, 0);

              // let jia = new createjs.Bitmap(App.loader.getResult("jia"));
              // let jian = new createjs.Bitmap(App.loader.getResult("jian"));
              const correctBox = new createjs.Container();
              const correctImgBox = new createjs.Container();
              const maskCorrectImgBox = new createjs.Container();
              gameContainer.addChild(back, poster, plantr, plantl, correctBox, correctImgBox);
              // init word
              const wordContainer = new createjs.Container();
              // setTimeout(()=> {
              //     gameContainer.removeChild(wordContainer)
              // },4000)

              wordContainer.setTransform(850, 264, 1, 1, 0, 0, 0, 0, 0);
              const initCountDownTime = (seconds: number) => {
                clearInterval(that.countdownTimer);
                this.countTime.setPaused(true);
                //     // speed+= 400;
                this.progressshape.x = -(797 / that.countdownTime) * seconds + 15;
                this.countTime = createjs.Tween.get(this.progressshape)
                  .to({ x: -that.progressWidth + 15 }, that.countdownTime, createjs.Ease.easeOut)
                  .call(() => {
                    // 弹出结束
                    that.fastPsoterGameErr().then((res: any) => {
                      if (res.data.code == 0) {
                        that.residueDegree = res.data.data.residueDegree;
                        // 弹出结束
                        showMask();
                      }
                    });
                    // 清除定时器
                    // clearInterval(that.countdownTimer)
                  });
                that.countdownTimer = setInterval(() => {
                  that.currentCountDownTime -= 1000;
                }, 1000);
              };
              const initWord = () => {
                const checkedContainer = new createjs.Container();
                checkedContainer.x = 850;
                checkedContainer.y = 264;

                wordContainer.removeAllChildren();
                // checkedContainer.removeAllChildren();
                // init width x y
                let offsetX = 0;
                const offsetY = 0;
                const ruleX = 359 + 60;
                const ruleY = 234 + 62;
                that.fastPsoterGame(that.para).then((res: any) => {
                  checkedContainer.removeAllChildren();
                  that.canClick = true;
                  // 第一次加载完成
                  that.setDataLoading(false);
                  that.data = res.data.data && res.data.data.scwl;
                  that.gameStatisticsId = res.data.data.gameStatistics.gameStatisticsId;
                  that.residueDegree = res.data.data.residueDegree;
                  // 随机一个正确的答案
                  const correctAnswer = that.data[Math.round(Math.random() * 3)];
                  correctImgBox.removeAllChildren();
                  maskCorrectImgBox.removeAllChildren();
                  correctBox.removeAllChildren();
                  correctImgBox.addChild(mask);
                  correctBox.addChild(show);
                  correctBox.setTransform(200, 261, 1, 1, 0, 0, 0, 0, 0);
                  correctImgBox.setTransform(170, 441, 1, 1, 0, 0, 0, 0, 0);
                  // let correctImg = new createjs.Bitmap('http://word.ebopo.cn/vte/images/pic/' + correctAnswer.pic);
                  maskCorrectImgBox.setTransform(720, 407, 1, 1, 0, 0, 0, 0, 0);
                  // correctImg.scaleX = 2;
                  // correctImg.scaleY = 2;
                  // correctImg.setBounds(130, 30, 410, 260);
                  // console.log(correctImg)
                  const image = new Image();
                  image.src = correctAnswer.pic;
                  image.onload = function () {
                    const correctImg = new createjs.Bitmap(image);
                    correctImg.scaleX = 420 / image.width;
                    correctImg.scaleY = 260 / image.height;
                    correctImg.x = 66;
                    correctImg.y = 32;
                    correctImgBox.addChild(correctImg);

                    // mask img
                    const maskImg = new createjs.Bitmap(image);
                    maskImg.scaleX = 250 / image.width;
                    maskImg.scaleY = 270 / image.height;
                    // maskImg.x = 66;
                    // maskImg.y = 32;
                    maskCorrectImgBox.addChild(maskImg);
                  };
                  let correctText;
                  // console.log(correctAnswer.wordDefinition.length)
                  if (correctAnswer.wordDefinition.length > 17 && correctAnswer.wordDefinition.length <= 30) {
                    correctText = new createjs.Text(correctAnswer.wordDefinition, '33px bold impact', '#FFFFFF');
                  } else if (correctAnswer.wordDefinition.length <= 17) {
                    correctText = new createjs.Text(correctAnswer.wordDefinition, '46px bold impact', '#FFFFFF');
                  } else if (correctAnswer.wordDefinition.length > 30) {
                    correctText = new createjs.Text(correctAnswer.wordDefinition, '25px bold impact', '#FFFFFF');
                  }

                  correctText.set({
                    textAlign: 'center',
                    textBaseline: 'middle',
                    x: 464 / 2,
                    lineWidth: 464,
                    y: 136 / 2,
                    maxWidth: 400,
                  });
                  correctBox.addChild(correctText);

                  // -------------------
                  that.data.map((item: any, index: number) => {
                    const wordItem = new createjs.Container();
                    // hover checked
                    // let hoving = new createjs.Bitmap(App.loader.getResult("wordh"));
                    // let right = new createjs.Bitmap(App.loader.getResult("right"));
                    wordItem.cursor = 'pointer';
                    // messagebg
                    const messagebg = new createjs.Bitmap(App.loader.getResult('messagebg'));
                    // shape.graphics.beginFill("#ffffff").drawRect(0, 0, 270, 147);
                    let text: any;
                    let textHover: any;
                    // 字符少于8个
                    function replaceStr(str: any) {
                      return str.replace(/(.{1})/g, '$1 ');
                    }
                    function CheckChinese(val: any) {
                      const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
                      return reg.test(val);
                    }
                    if (CheckChinese(item.content)) {
                      item.content = replaceStr(item.content);
                    }
                    // item.word
                    text = new createjs.Text(item.word, '56px bold impact', '#883F05');
                    textHover = new createjs.Text(item.word, '56px bold impact', '#FF6800');
                    textHover.shadow = new createjs.Shadow('#666666', 2, 2, 2); // 创建文字阴影
                    text.set({
                      textAlign: 'center',
                      textBaseline: 'middle',
                      x: 359 / 2,
                      lineWidth: 340,
                      y: 234 / 2,
                    });

                    wordItem.addChild(messagebg, text);
                    wordItem.x = offsetX;

                    wordContainer.addChild(wordItem);
                    if (index < 2) {
                      wordItem.x = offsetX;
                      wordItem.y = 0;
                      right.x = offsetX;
                      right.y = 0;
                    } else {
                      wordItem.x = offsetX - 2 * ruleX;
                      wordItem.y = ruleY;
                      right.x = offsetX - 2 * ruleX;
                      right.y = ruleY;
                    }
                    offsetX += ruleX;
                    // 鼠标事件不穿透到子元素
                    wordItem.mouseChildren = false;
                    // wordItem.on('mouseover', (e: any) => {
                    //   console.log(textHover.getBounds());
                    //   textHover.set({
                    //     textAlign: 'center',
                    //     textBaseline: 'middle',
                    //     x: wordItem.x + 359 / 2,
                    //     lineWidth: 340,
                    //     y: wordItem.y + 234 / 2,
                    //   });

                    //   checkedContainer.addChild(textHover);
                    //   mousePointOver.play();
                    // });
                    // wordItem.on('mouseout', (e: any) => {
                    //   checkedContainer.removeChild(textHover);
                    //   // checkedContainer.addChild(textHover);

                    //   // mousePointOver.play();
                    // });

                    wordItem.on('click', (e: any) => {
                      checkedContainer.removeChild(textHover);
                      if (!that.canClick) {
                        return false;
                      }
                      that.canClick = false;
                      if (correctAnswer.ucwId == item.ucwId) {
                        // 1584, 753
                        // 正确 poster
                        createjs.Tween.get(wordItem, { loop: true })
                          .to({ rotation: 360 }, 1000, createjs.Ease.quartOut);
                        createjs.Tween.get(wordItem, { loop: true })
                          .to({ alpha: 0 }, 1500, createjs.Ease.quartOut);
                        createjs.Tween.get(wordItem, { loop: true })
                          .to({
                            x: 1284, y: 853, scaleX: 0.1, scaleY: 0.1,
                          }, 3000, createjs.Ease.quartOut);

                        createjs.Tween.get(poster)
                          .to({ rotation: -40 }, 100, createjs.Ease.quartOut)
                          .to({ rotation: 5 }, 200, createjs.Ease.quartOut)
                          .to({ rotation: -35 }, 100, createjs.Ease.quartOut)
                          .to({ rotation: 15 }, 200, createjs.Ease.quartOut)
                          .to({ rotation: -5 }, 100, createjs.Ease.quartOut)
                          .to({ rotation: 0 }, 100, createjs.Ease.quartOut);

                        soundscore.play();
                        addScore(1);

                        setTimeout(() => {
                          this.scoreContainer.removeAllChildren();
                          const scoreTimes = this.score(that.scoreNumber);
                          this.scoreContainer.addChild(scoreTimes);
                          wordContainer.removeAllChildren();
                          that.para.firstLoad = 1;
                          that.para.gameStatisticsId = that.gameStatisticsId;
                          initWord();
                        }, 1000);
                        that.scoreNumber++;
                      } else {
                        // 错误
                        // 错误计数
                        sounderror.play();
                        that.errNumber++;
                        // 失败动效
                        createjs.Tween.get(wordItem)
                          .to({ x: wordItem.x - 20 }, 100, createjs.Ease.quartOut)
                          .to({ x: wordItem.x + 15 }, 100, createjs.Ease.quartOut)
                          .to({ x: wordItem.x - 10 }, 100, createjs.Ease.quartOut)
                          .to({ x: wordItem.x + 5 }, 100, createjs.Ease.quartOut)
                          .to({ x: wordItem.x - 5 }, 100, createjs.Ease.quartOut)
                          .to({ x: wordItem.x + 0 }, 100, createjs.Ease.quartOut);
                        if (that.errNumber == 5) {
                          this.errContainer.removeAllChildren();
                          const errTimesMax = this.err(that.errNumber);
                          this.errContainer.addChild(errTimesMax);
                          that.fastPsoterGameErr().then((res: any) => {
                            if (res.data.code == 0) {
                              that.residueDegree = res.data.data.residueDegree;
                              // 弹出结束
                              showMask();
                            }
                          });
                          return false;
                        }
                        addScore(2);
                        setTimeout(() => {
                          this.errContainer.removeAllChildren();
                          const errTimesMax = this.err(that.errNumber);
                          this.errContainer.addChild(errTimesMax);
                          that.para.firstLoad = 1;
                          that.para.gameStatisticsId = that.gameStatisticsId;
                          // 错误计数
                          const errmask = this.initMask();
                          errmask.on('mouseover', () => {

                          });
                          const correctAnswerDefinition = new createjs.Text(correctAnswer.wordDefinition, '24px bold impact', '#8C6B57');
                          const correctAnswerText = new createjs.Text(correctAnswer.word, '30px bold impact', '#FF7300');
                          correctAnswerText.set({
                            x: 1003,
                            lineWidth: 193,
                            y: 455,
                          });
                          correctAnswerDefinition.set({
                            x: 1003,
                            lineWidth: 193,
                            y: 542,
                          });
                          // 正确答案文字
                          // correctAnswerText.setTransform(1003, 455, 1, 0, 0, 0, 0, 0);
                          gameContainer.addChild(errmask, errdialog, maskCorrectImgBox, errclose, correctAnswerText, correctAnswerDefinition);
                          errclose.cursor = 'pointer';
                          errclose.removeAllEventListeners();
                          errclose.on('click', () => {
                            // this.countTime.setPaused(true);
                            gameContainer.removeChild(errmask, errdialog, maskCorrectImgBox, errclose, correctAnswerText, correctAnswerDefinition);
                            that.para.firstLoad = 1;
                            that.para.gameStatisticsId = that.gameStatisticsId;
                            initWord();
                          });
                        }, 1000);
                      }
                    });
                    // map
                  });
                });

                // 选中的container

                // 测试用
                // gameContainer.addChild(scorebg, five);
                gameContainer.addChild(checkedContainer);
              };
              // mask
              const showMask = () => {
                clearInterval(that.countdownTimer);
                this.countTime.setPaused(true);
                that.currencyRightNumber = 0;
                that.currentCountDownTime = that.countdownTime;
                const maskContainer = new createjs.Container();

                const mask = this.initMask();
                const dialog = new createjs.Bitmap(App.loader.getResult('dialog'));
                maskContainer.setTransform(676, 319, 1, 1, 0, 0, 0, 0, 0);
                const onemore = new createjs.Bitmap(App.loader.getResult('onemore'));
                const onemorea = new createjs.Bitmap(App.loader.getResult('onemorea'));
                const selected = new createjs.Bitmap(require('@/assets/images/game/linker/selected.png'));
                const unselected = new createjs.Bitmap(require('@/assets/images/game/linker/uns.png'));
                onemore.setTransform(89, 310, 1, 1, 0, 0, 0, 0, 0);
                onemorea.setTransform(89, 310, 1, 1, 0, 0, 0, 0, 0);
                // 默认选中状态

                if (that.para.playModel == 1) {
                  unselected.alpha = 0;
                  selected.alpha = 1;
                } else {
                  unselected.alpha = 1;
                  selected.alpha = 0;
                }
                selected.cursor = 'pointer';
                unselected.cursor = 'pointer';
                // 123
                const text = new createjs.Text(`今天还可以玩${that.residueDegree}次`, '20px PingFangSC-Regular', '#FFC800');
                selected.on('click', (e: any) => {
                  // 不展示 不计入排行
                  that.para.playModel = 0;
                  selected.alpha = 0;
                  // text.alpha = 0;
                  unselected.alpha = 1;
                });
                unselected.on('click', (e: any) => {
                  // 展示 计入排行
                  that.para.playModel = 1;
                  selected.alpha = 1;
                  // text.alpha = 1;
                  unselected.alpha = 0;
                });
                onemore.cursor = 'pointer';
                onemorea.cursor = 'pointer';
                onemore.on('mousedown', (e: any) => {
                  // 再来一局
                  if (that.residueDegree == 0) {
                    that.$router.push(
                      {
                        path: '/vocabulary/afterschoolexpand?type=through',
                        // query: {
                        //     id: 4,
                        //     // gameId: scope.row.game.id
                        // }
                      },
                    );
                    return false;
                  }
                  // maskContainer.rem oveAllChildren();
                  maskContainer.removeChild(onemore);

                  // this.progressshape.x = 0;

                  // int progress
                  initCountDownTime(0);
                  // 重置
                  wordContainer.removeAllChildren();
                  that.para.firstLoad = 0;
                  that.para.sendScore = 1;
                  that.para.gameStatisticsId = '';
                  initWord();
                  that.app.stage.update();
                });
                onemore.on('pressup', (e: any) => {
                  // onemore.alpha = 0;
                  // 如果有游戏次数 重新开始
                  // 失败次数重置
                  that.errNumber = 0;
                  const errTimesMax = this.err(that.errNumber);
                  this.errContainer.addChild(errTimesMax);
                  // 得分重置
                  that.scoreNumber = 0;
                  const scoreTimes = this.score(that.scoreNumber);
                  this.scoreContainer.addChild(scoreTimes);
                  that.app.stage.removeChild(mask, maskContainer);
                  that.app.stage.update();
                });
                // one more 不玩了


                const goover = new createjs.Bitmap(App.loader.getResult('goover'));
                const goovera = new createjs.Bitmap(App.loader.getResult('goovera'));
                goover.setTransform(314, 310, 1, 1, 0, 0, 0, 0, 0);
                goovera.setTransform(314, 310, 1, 1, 0, 0, 0, 0, 0);
                selected.setTransform(122, 198, 1, 1, 0, 0, 0, 0, 0);
                unselected.setTransform(122, 198, 1, 1, 0, 0, 0, 0, 0);
                text.setTransform(215, 249, 1, 1, 0, 0, 0, 0, 0);
                goover.cursor = 'pointer';
                goovera.cursor = 'pointer';
                goover.on('mousedown', (e: any) => {
                  //
                  goover.alpha = 0;
                });
                goover.on('pressup', (e: any) => {
                  that.$router.push(
                    {
                      path: '/vocabulary/afterschoolexpand?type=through',
                      // query: {
                      //     id: 4,
                      //     // gameId: scope.row.game.id
                      // }
                    },
                  );
                });
                maskContainer.addChild(dialog, goovera, goover, onemorea, onemore, selected, unselected, text);
                that.app.stage.addChild(mask, maskContainer);
                // 防止穿透的另一种方法 覆盖层事件覆盖
                mask.on('mouseover', () => {

                });
              };
              // 时间提示
              const addTimeAn = (type: number) => {
                const scorebg = new createjs.Bitmap(App.loader.getResult('scorebg'));
                const five = new createjs.Bitmap(App.loader.getResult('five'));
                const fifteen = new createjs.Bitmap(App.loader.getResult('fifteen'));

                five.setTransform(863, 481, 1, 1, 0, 0, 0, 0, 0);
                fifteen.setTransform(863, 481, 1, 1, 0, 0, 0, 0, 0);
                scorebg.setTransform(769 + scorebg.getBounds().width / 2, 393 + scorebg.getBounds().height / 2, 1, 1, 0, 0, 0, scorebg.getBounds().width / 2, scorebg.getBounds().height / 2);
                if (type == 5) {
                  gameContainer.addChild(scorebg, five);
                } else if (type == 15) {
                  gameContainer.addChild(scorebg, fifteen);
                }
                createjs.Tween.get(scorebg, { loop: true })
                  .to({ rotation: 180 }, 1000, createjs.Ease.easeOut)
                  .call(() => {
                    createjs.Tween.get(fifteen)
                      .to({ alpha: 0 }, 800, createjs.Ease.easeOut)
                      .call(() => {
                        gameContainer.removeChild(fifteen);
                      });
                    createjs.Tween.get(five)
                      .to({ alpha: 0 }, 800, createjs.Ease.easeOut)
                      .call(() => {
                        gameContainer.removeChild(five);
                      });
                    createjs.Tween.get(scorebg)
                      .to({ alpha: 0 }, 800, createjs.Ease.easeOut)
                      .call(() => {
                        gameContainer.removeChild(scorebg);
                      });
                  });
              };
              // const addLetter = () => {

              // }
              // addScore
              const addScore = (type: number) => {
                const addbox = new createjs.Container();
                const addtext = new createjs.Text('+ 1', 'bold 100px impact', '#44D7B6');
                const minusbox = new createjs.Container();
                const minustext = new createjs.Text('- 1', 'bold 100px impact', '#F669AB');
                addbox.setTransform(863, 481, 1, 1, 0, 0, 0, 0, 0);
                addbox.addChild(addtext);
                minusbox.setTransform(863, 481, 1, 1, 0, 0, 0, 0, 0);
                minusbox.addChild(minustext);
                if (type == 1) {
                  gameContainer.addChild(addbox);
                  createjs.Tween.get(addbox)
                    .to({ x: 1181, y: 54, alpha: 0.3 }, 1000, createjs.Ease.easeOut)
                    .call(() => {
                      gameContainer.removeChild(addbox);
                    });
                } else if (type == 2) {
                  gameContainer.addChild(minusbox);
                  createjs.Tween.get(minusbox)
                    .to({ x: 1476, y: 54, alpha: 0.3 }, 1000, createjs.Ease.easeOut)
                    .call(() => {
                      gameContainer.removeChild(minusbox);
                    });
                }
              };

              gameContainer.addChild(wordContainer, goback, progressContainer, sound, nosound, logo, wrong, score, this.errContainer, this.scoreContainer);
              // 禁止播放按钮
              nosound.alpha = 0;
              gameContainer.alpha = 0;
              // readyContainer.alpha = 0;

              that.app.stage.addChild(gameContainer, readyContainer);
              // 音量事件
              sound.on('click', (e: any) => {
                that.bgMusic.stop();
                // 更换图片
                nosound.alpha = 1;
              });
              nosound.cursor = 'pointer';
              nosound.on('click', (e: any) => {
                that.bgMusic.play();
                // 更换图片
                nosound.alpha = 0;
              });
              // start
              btn.cursor = 'pointer';
              btn.on('click', (e: any) => {
                initWord();
                readyContainer.alpha = 0;
                gameContainer.alpha = 1;
                initCountDownTime(0);
                nosound.alpha = 0;
                // 播放背景音乐
                that.bgMusic.play();
              });
              // back
              goback.cursor = 'pointer';
              goback.on('click', (e: any) => {
                // mask = this.init_mask();
                that.bgMusic.stop();
                // readyContainer.alpha = 1;
                // gameContainer.alpha = 0;
                that.$router.push({
                  path: '/vocabulary/afterschoolexpand?type=through',
                  // query: {
                  //     id: 4,
                  //     // gameId: scope.row.game.id
                  // }
                });
              });
              // sound
              sound.cursor = 'pointer';

              createjs.Tween.get(btn, { loop: true })
                .to({ scaleX: 1.2, scaleY: 1.2 }, 400, createjs.Ease.linear)
                .to({ scaleX: 0.9, scaleY: 0.9 }, 400, createjs.Ease.linear);


              this.makeResponsive(true, 'both', false, 1, {
                canvas: 'root',
              }, that.app);
              this.startAnimation(that.app.stage);
            }

            protected score(value: number) {
              this.scoreContainer.removeAllChildren();
              const scoreTimes = new createjs.Text(value, '35px impact', '#44D7B6');
              scoreTimes.setTransform(150, 30, 1, 1, 0, 0, 0, 0, 0);
              return scoreTimes;
            }

            protected err(value: number) {
              this.errContainer.removeAllChildren();
              const errTimesMax = new createjs.Text(`${value} / 5`, '35px impact', '#66461F');
              errTimesMax.setTransform(130, 33, 1, 1, 0, 0, 0, 0, 0);
              return errTimesMax;
            }
            // 倒计时
            // protected
            // protected mask() {

        // }
        // protected onAssetsLoaded(loader, resources) {
        //     that.init();
        //     super.onAssetsLoaded();
        // }
      }

      // 实例化
      const game = new CurrentGame(config);
    }

    // ajax
    private async fastPsoterGame(para: any) {
      return await Game.fastPsoterGame(para);
    }

    // 改为时间结束调接口
    private async fastPsoterGameErr() {
      const para = {
        courseId: window.LS.get('vteData').course.courseId,
        firstLoad: 1,
        gameId: 1,
        accuracyNum: this.scoreNumber,
        errorNum: this.errNumber,
        playModel: 1, // 是否记录排行榜
        userId: window.LS.get('vteData').user.userId,
        gameStatisticsId: this.gameStatisticsId,
        sendScore: 0, // 结束游戏的时候 发送成绩
      };
      return await Game.fastPsoterGame(para);
    }
}
